import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { CountryDto } from '@/types/tenant';
import { getCountries } from '@/services/tenantService';

interface ReferenceDataState {
  countries: CountryDto[];
  countriesLoaded: boolean;
  countriesLoading: boolean;
  countriesError: boolean;
  fetchCountries: () => Promise<void>;
}

export const useReferenceDataStore = create<ReferenceDataState>()(
  devtools(
    (set, get) => ({
      countries: [],
      countriesLoaded: false,
      countriesLoading: false,
      countriesError: false,

      fetchCountries: async () => {
        if (get().countriesLoaded || get().countriesLoading || get().countriesError) return;
        set({ countriesLoading: true });
        try {
          const data = await getCountries({ size: 300 });
          set({ countries: data.content, countriesLoaded: true, countriesLoading: false });
        } catch {
          set({ countriesLoading: false, countriesError: true });
        }
      },
    }),
    { name: 'reference-data-store' },
  ),
);
